/** Belgium - Wallonia */
export const BE_WAL = "BE_WAL";
/** Belgium - Flanders */
export const BE_VLA = "BE_VLA";
/** Belgium - Bruxelles */
export const BE_RBC = "BE_RBC";
/** Belgium - Hainaut / Wallonia */
export const BE_HAINAUT = "BE_HAINAUT";